import { FC, useState } from 'react';
import { Button, Flexbox, Spinner, Text } from '@morressier/ts';
import { FaKey } from 'react-icons/fa';
import useSwr from 'swr';
import { completeRtmpStream, VIDEO_API_URL, standaloneFetcher } from 'api/livestream-rtmp';
import { logEvent } from 'utils/eventTracking';
import { logger } from 'utils/logger';
import ActionModal from 'components/Modals/ActionModal';
import ModalRTMPCredentials from './ModalRtmp';

const RtmpHeaderOptions: FC<{
  sessionId: string;
  eventId: string;
  showLoginRequired: boolean;
  userId: string | undefined;
}> = props => {
  const { sessionId, eventId, userId, showLoginRequired } = props;
  const [showConnectRtmpModal, setShowConnectRtmpModal] = useState(false);
  const [showEndLivestreamModal, setShowEndLivestreamModal] = useState(false);
  const { data: rtmpStream, error: rtmpStreamError } = useSwr<RtmpStream, Error>(
    `${VIDEO_API_URL}/${sessionId}?isOrganizer=true`,
    standaloneFetcher,
  );

  const handleEndLivestream = async () => {
    try {
      await completeRtmpStream(eventId, sessionId);
      setShowEndLivestreamModal(false);
      logEvent('HYBRID_CLICKED_END_LIVESTREAM', {
        user_id: userId,
        session_id: sessionId,
      });
    } catch (error) {
      logger.error('Handle end live stream:', error);
    }
  };

  if (showLoginRequired || rtmpStream?.stream_ended_at) return null;
  if (rtmpStreamError) return <Text>{rtmpStreamError.message}</Text>;
  if (!rtmpStream) return <Spinner />;

  return (
    <>
      <Flexbox>
        {!rtmpStream.stream_ended_at && (
          <Button
            color="primary"
            onClick={() => {
              setShowConnectRtmpModal(true);
              logEvent('HYBRID_CLICKED_CONNECT_RTMP');
            }}
          >
            <FaKey /> Connect RTMP
          </Button>
        )}
        {(rtmpStream.mux_stream_status === 'active' || rtmpStream.stream_started_at) &&
          !rtmpStream.stream_ended_at && (
            <Button
              style={{ marginLeft: '1rem' }}
              color="danger"
              onClick={() => {
                setShowEndLivestreamModal(true);
                logEvent('HYBRID_CLICKED_END_LIVESTREAM_MODAL', {
                  user_id: userId,
                  session_id: sessionId,
                });
              }}
            >
              End Livestream
            </Button>
          )}
      </Flexbox>
      {showConnectRtmpModal && (
        <ModalRTMPCredentials
          rtmpUrl={rtmpStream.rtmp_url}
          rtmpStreamKey={rtmpStream.mux_stream_key}
          cancelAction={() => setShowConnectRtmpModal(false)}
        />
      )}
      {showEndLivestreamModal && (
        <ActionModal
          title="End Livestream"
          bodyText="If you end the Session, you will not be able to start it again. A recording will be available later. Proceed?"
          acceptText="End Livestream"
          acceptAction={handleEndLivestream}
          acceptButtonColor="danger"
          cancelText="Cancel"
          cancelAction={() => setShowEndLivestreamModal(false)}
        />
      )}
    </>
  );
};

export default RtmpHeaderOptions;
